const isValidNumber = value => {
  if (value === 0) return true;
  return value != null;
};

const paddingStringToObject = paddingString => {
  var _paddingString$match;

  const numberPattern = /\d+/g;
  const [top, right, bottom, left] = ((_paddingString$match = paddingString.match(numberPattern)) === null || _paddingString$match === void 0 ? void 0 : _paddingString$match.map(paddingSide => isValidNumber(paddingSide) ? paddingSide : null)) || [];
  const hasValidRight = isValidNumber(right);
  const alternateLeft = hasValidRight ? right : top;
  return {
    paddingTop: Number(top),
    paddingRight: Number(hasValidRight ? right : top),
    paddingBottom: Number(isValidNumber(bottom) ? bottom : top),
    paddingLeft: Number(isValidNumber(left) ? left : alternateLeft)
  };
};

export { paddingStringToObject };
